import axios from 'axios';
import { req } from './axiosFun';

// 查询科目树
export const selectAreaTree = (params) => {
  return req("post", "/api/common/queryAllSubject", params)
};
// 获取标签列表
export const queryTagList = (params) => {
  return req("post", "/api/common/queryTagList", params)
};

// 科目数据 列表
export const querySubjectList = (params) => {
  return req("get", "/api/common/querySubjectList" + params, '')
};

// 科目数据 新增
export const saveSubject = (params) => {
  return req("post", "/api/common/saveSubject", params)
};

// 科目数据 修改
export const updateSubject = (params) => {
  return req("post", "/api/common/updateSubject", params)
};

// 科目数据 删除
export const deleteSubjectById = (params) => {
  return req("post", "/api/common/deleteSubjectById", params)
};

// 科目数据 详情
export const querySubjectDetail = (params) => {
  return req("get", "/api/common/querySubjectDetail?id=" + params, '')
};

/*
* 科目标签信息
* */
// 科目配置 根据科目id查询科目配置信息
export const queryTagBySubjectId = (params) => {
  return req("post", "/api/subjectDescribe/queryTagBySubjectId", params)
};
// 体验试卷 根据科目id查询体验试卷
export const queryTestPapeBySubjectId = (params) => {
  return req("post", "/api/subjectDescribe/queryTestPapeBySubjectId", params)
};



/*
* 科目配置信息
* */

// 科目配置 列表
export const findSubjectDescribeList = (params) => {
  return req("post", "/api/subjectDescribe/queryByPage", params)
};

// 科目配置 保存
export const savaSubjectDescribe = (params) => {
  return req("post", "/api/subjectDescribe/savaSubjectDescribe", params)
};

// 科目配置 修改
export const updateSubjectDescribe = (params) => {
  return req("post", "/api/subjectDescribe/updateSubjectDescribe", params)
};

// 科目配置 删除
export const deleteSubjectDescribe = (params) => {
  return req("post", "/api/subjectDescribe/deleteSubjectDescribe", params)
};

// 科目配置 详情
export const querySubjectDescribeDetail = (params) => {
  return req("post", "/api/subjectDescribe/querySubjectDescribeDetail", params)
};

// 科目配置 根据科目id查询科目配置信息
export const querySubjectDescribeBySubjectId = (params) => {
  return req("post", "/api/subjectDescribe/querySubjectDescribeBySubjectId", params)
};


// 科目配置信息 公共方法
export const querySubjectDesc = (params) => {
  return req("post", "/api/common/querySubjectDesc", params)
};




// WEBPACK FOOTER //
// ./src/api/subjectTree.js